import React from 'react';
import { FaTh, FaMapMarkedAlt } from 'react-icons/fa';
import './ViewToggle.css';

const ViewToggle = ({ view, onViewChange }) => (
  <div className="view-toggle" role="tablist" aria-label="View mode">
    <button
      className={`vt-btn ${view === 'grid' ? 'vt-active' : ''}`}
      onClick={() => onViewChange('grid')}
      role="tab"
      aria-selected={view === 'grid'}
      aria-label="Grid view"
      type="button"
    >
      <FaTh size={13} />
      <span>Grid</span>
    </button>
    <button
      className={`vt-btn ${view === 'map' ? 'vt-active' : ''}`}
      onClick={() => onViewChange('map')}
      role="tab"
      aria-selected={view === 'map'}
      aria-label="Map view"
      type="button"
    >
      <FaMapMarkedAlt size={13} />
      <span>Map</span>
    </button>
  </div>
);

export default ViewToggle;
